<!-- 销售订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">

                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :class="`${formOneValue.entityField}1`"
                                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 日期 -->
                                                    <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                        :isShowLong="false" :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)">
                                                    </df-date>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.entityField == 'coName'" class="item"
                                                        :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                            :disabled="sendDataInfo.detailList.length > 0 ? true : false">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                                icon="el-icon-search" :disabled="sendDataInfo.detailList.length > 0 ? true : false">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                            :disabled="(formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                                icon="el-icon-search"
                                                                :disabled="(formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <el-input class="remark" v-else-if="formOneValue.entityField == 'remark'" type="textarea" :rows="2" :maxlength="$store.state.inputLength" v-model="sendDataInfo[formOneValue.entityField]"
                                                        :disabled="formOneValue.isChange == 0">
                                                    </el-input>
                                                    <!-- string类型 -->
                                                    <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.detailList.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)"
                                                        v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo.isWms == 1 ?'是' : '否' }}</span>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                        {{getValue(sendDataInfo[formOneValue.entityField],formOneValue.entityField, formOneValue.fieldType,formOneValue.formatterContent) }}
                                                    </span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>

                                    <!-- 明细操作 -->
                                    <el-form :inline="true" size="mini">
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">新增明细</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.detailList.length < 1">删除明细</el-button>
                                            <el-button type="primary" @click="openExtSearch(9495997656, '', '', 'kcbId')">提取库存包</el-button>
                                            <el-button type="primary" @click="openExtSearch(831837436283884, '', '', 'umId')">提取手术包</el-button>
                                            <el-button v-if="dataActionBox.actionType === 0" type="primary" @click="sendDataAction('sendDataInfo', 1)">保存为手术包</el-button>
                                            <el-button type="primary" @click="openExtSearch(183792239277382, '', '', 'suomId')">提取手术订单</el-button>
                                            <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                            <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                                            <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                                (Alt+F1：新增明细</el-link>
                                            <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                                Alt+F2：删除明细)</el-link>
                                        </div>
                                        <!-- 明细信息 -->
                                        <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.detailList" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                            @selection-change="handleSelectionChange" @sort-change="sortChange" border size="mini" :height="mxHeight">
                                            <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column type="index" width="50" label="序号"> </el-table-column>
                                            <template v-for="(formOneValue, formOneKey) in mxForm.jurconfigform">
                                                <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" :key="formOneKey" v-if="formOneValue.isShow == 1" :min-width="formOneValue.fieldWeight" show-overflow-tooltip
                                                    :sortable="formOneValue.entityField == 'woadPnumber' || formOneValue.entityField == 'saleableNum'">
                                                    <template slot-scope="scope">
                                                        <!-- 显示通用名称 -->
                                                        <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                                            @keyup.enter.native="openExtSearch(formOneValue.extractId, scope.$index, formOneValue.setField, 'bgmName')"
                                                            v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                            <el-button @click="openExtSearch(formOneValue.extractId, scope.$index, formOneValue.setField, 'bgmName', formOneValue.focusField)" slot="append" icon="el-icon-search">
                                                            </el-button>
                                                        </el-input>
                                                        <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'woadPnumber'&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number"
                                                            v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"></el-input>
                                                        <!-- 备注 -->
                                                        <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                            v-else-if="formOneValue.entityField == 'woadRemark'&& dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                            v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                        </el-input>

                                                        <el-select v-else-if="formOneValue.entityField == 'isTicket'" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                                            <el-option label="是" :value="1"></el-option>
                                                            <el-option label="否" :value="0"></el-option>
                                                        </el-select>
                                                        <span v-else-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(sendDataInfo.detailList[scope.$index][formOneValue.riftField])">{{sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</a>
                                                        </span>
                                                        <!-- 生产日期 -->
                                                        <span v-else-if="formOneValue.fieldType == 'date'">
                                                            <span v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                                {{$common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])}}
                                                            </span>
                                                        </span>
                                                        <span v-else>
                                                            {{sendDataInfo.detailList[scope.$index][formOneValue.entityField]}}
                                                        </span>
                                                    </template>
                                                </el-table-column>
                                            </template>
                                        </el-table>
                                    </el-form>

                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan">
                </v-foot>
            </div>

        </div>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="showCmSustateDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="[{level: 0, data: cmSustateRemark}]" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showCmSustateDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionSchemeAll v-if="seType == 'bgmName'" :detailsObj="detailsObj" :coId="coIds" :extractParamsData="extractParamsData" :choiceDetail='choiceDetail' ref="extractionScheme" :interceptFlag="true" :id="exId" :ppId="ppId"
                @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
            <ExtractionSchemeSSDD v-else-if="seType=='suomId'" :coId="coIds" :detailsObj="detailsObj" :extractParamsData="extractParamsData" :choiceDetail='choiceDetail' ref="extractionScheme" :interceptFlag="true" :id="exId" :ppId="ppId"
                @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
            <ExtractionScheme v-else :coId="coIds" :detailsObj="detailsObj" :extractParamsData="extractParamsData" :choiceDetail='choiceDetail' ref="extractionScheme" :interceptFlag="true" :id="exId" :ppId="ppId" @TranData="getDataByChen"
                @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog title="导入" v-if="importShow" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload :errorUrl="'pwoapply/exportSuFail'" :listShow="true" v-if="importShow" :parentSearchData="importObj" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
        <el-dialog title="保存手术包" :visible.sync="surgeryTypeFlag" width="350px" :modal-append-to-body="true" :append-to-body="true">
            <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" :inline-message="false" :show-message="false">
                <el-form-item label="手术包类型" prop="surgeryType">
                    <el-select style="width: 200px;" clearable size="mini" v-model="ruleForm.surgeryType" placeholder="请选择">
                        <el-option v-for="item in surgeryTypeList" :key="item.id" :label="item.surgeryName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手术包名称" prop="umName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input style="width: 200px;" type="text" v-model.trim="ruleForm.umName"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="surgeryTypeFlag = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="surgeryClick">确 定</el-button>
            </span>
        </el-dialog>
        <div v-show="false">{{ some }}</div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionSchemeAll from "../byComponents/ExtractionSchemeAll.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";

export default {
    name: "beforehandStockOutAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionSchemeAll,
        ExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            showDialog: false,
            dialogList: [],
            detailRules: false, //规则
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            inputel: "", //所有input对象
            detaislDataInfo: {},
            showTabs: "",
            selectedDetailsIndex: 0,
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            ormId: "",
            coId: 0,
            seType: "",
            seIndex: 0,
            seWidth: "0",
            mxHeight: 0,
            isLoaded: false,
            parentSearchData: {
                orderType: 0, //	订单类型0.药品1.器械
            },
            selectedRow: [], // 当前已选择行
            mainFormList: [], //过滤的主表单
            tabForm: [], // tab循环的主表单
            formDataList: [],
            mxForm: [],
            footForm: [],
            sField: "", // 赋值字段
            fField: "", //焦点字段
            some: 0,
            surgeryTypeList: [],
            //----------
            DialogExtract: false,
            exId: "",
            exWidth: "",
            exTitle: "",
            ppId: "umId",
            coIds: "",
            detailsObj: {},
            choiceDetail: false,
            extractParamsData: {},
            importShow: false,
            importType: "",
            url: "",
            importObj: {
                coId: "",
                stId: "",
            },
            //------------------
            surgeryTypeFlag: false,
            ruleForm: {//手术包
                umName: "",
                surgeryType: "",
            },
            //------------------
            cmSustate: null,
            cmSustateRemark: "",
            showCmSustateDialog: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.detailList": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalCount = 0; //总条目数
                this.sendDataInfo.totalNumber = 0; // 总数量
                newValue.forEach((item, keys) => {
                    for (let key in item) {
                        if (item[key] == null || item[key] == "null") {
                            this.sendDataInfo.detailList[keys][key] = "";
                        }
                    }
                    if (item.woadPnumber > item.saleableNum) {
                        item.woadPnumber = item.saleableNum;
                        this.$message({
                            message: "销售数量不能大于可销数量",
                            type: "error",
                        });
                    }
                    this.$set(this.sendDataInfo.detailList[keys], 'woadPnumber', this.$common.updataNum('woadPnumber', item).woadPnumber)
                    this.sendDataInfo.totalNumber = NP.plus(
                        parseFloat(this.sendDataInfo.totalNumber),
                        parseFloat(item.woadPnumber)
                    );
                });
                this.sendDataInfo.totalCount = newValue.length;
            },
            deep: true,
        },
        "sendDataInfo.stName": {
            handler: function (newstr, oldValue) {
                if (!newstr) {
                    this.sendDataInfo.stId = "";
                }
            },
            deep: true,
        },
        "sendDataInfo.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    if (
                        this.dataActionBox.actionType == 0 ||
                        (this.dataActionBox.actionType == 1 &&
                            this.sendDataInfo.detailList.length == 0)
                    ) {
                        this.sendDataInfo.cmId = "";
                        this.sendDataInfo.salesId = "";
                        this.sendDataInfo.salesName = "";
                        this.sendDataInfo.caiId = "";
                        this.sendDataInfo.caiAddress = "";
                        this.sendDataInfo.recId = "";
                        this.sendDataInfo.recName = "";
                    }
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            if (val.list.length > 0) {
                var list = []
                val.list.forEach(item => {
                    list.push({})
                    for (const key in item) {
                        this.$set(list[list.length - 1], key, item[key])
                    }
                })
                this.sendDataInfo.detailList.push(...list)
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/pwoapply/downSuDetailExcel`
        },
        importDetails() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.importType = 'pwoapplyexportSuDetail'
                    this.url = 'pwoapply/exportSuDetail'
                    this.importObj.coId = this.sendDataInfo.coId
                    this.importObj.stId = this.sendDataInfo.stId
                    this.importObj.isSurgeryOrder = false
                    this.importShow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        openExtSearch(id, index = undefined, setfield, type, focusField) {
            this.coIds = ""
            this.exId = id;
            this.fField = focusField || ""
            this.seType = type || ""
            if (type == 'bgmName') {
                this.coIds = this.sendDataInfo.coId
                this.ppId = 'extractId'
                this.choiceDetail = false
                this.extractParamsData = JSON.parse(JSON.stringify(this.sendDataInfo))
                this.extractParamsData.bgmName = this.sendDataInfo.detailList[index].bgmName
                this.detailsObj = {
                    stId: this.sendDataInfo.stId
                }
            } else if (type == 'suomId') {
                this.ppId = 'suomId'
                this.choiceDetail = true
            } else if (id == 831837436283884) {
                this.ppId = 'umId'
                this.detailsObj = {
                    ormId: this.ormId,
                    coId: this.sendDataInfo.coId,
                    stId: this.sendDataInfo.stId,
                }
                this.choiceDetail = true
            } else if (id == 9495997656) {
                this.ppId = 'spCode'
                this.extractParamsData = JSON.parse(JSON.stringify(this.sendDataInfo))
                this.detailsObj = {
                    stId: this.sendDataInfo.stId,
                    coId: this.sendDataInfo.coId
                }
                this.choiceDetail = false
            }
            this.DialogExtract = true;
        },
        getDataByChen(val) {
            console.log(val);

            if (this.ppId == 'extractId' || this.ppId == 'umId') {
                //商品明细
                let bgiTypeArr = [],
                    bgiRateArr = [], bgmIds = [];
                this.sendDataInfo.detailList.forEach((v) => {
                    if (v.bgiType && v.bgiType != null && v.bgiType != "null") {
                        bgiTypeArr.push(v.bgiType);
                    }
                    if (v.outRate && v.outRate != null && v.outRate != "null") {
                        bgiRateArr.push(v.outRate);
                    }
                });
                var mx = []
                if (this.ppId == 'extractId') {
                    mx = JSON.parse(JSON.stringify(val))
                } else if (this.ppId == 'umId') {
                    mx = JSON.parse(JSON.stringify(val.arrlistbychen))
                }
                mx.forEach(item => {
                    item.isTicket = Number(this.ticket);
                    this.$set(item, 'woadPnumber', item.woadPnumber || 0)
                    this.$set(item, 'psmoney', item.psmoney || 0)
                    this.$set(item, 'money', item.money || 0)
                    if (item.isPackage != 1) {
                        if (item.bgiType && item.bgiType != null && item.bgiType != "null") {
                            bgiTypeArr.push(item.bgiType)
                        }
                        bgmIds.push(item.bgmId)
                    }
                })
                if (mx.length > 0 && bgmIds.length == 0) {
                    this.sendDataInfo.detailList.forEach((item, index) => {
                        if (item.bgmId == "" || item.bgmName == "") {
                            this.sendDataInfo.detailList.splice(index, 1)
                        }
                    })
                    if (this.sendDataInfo.detailList.length > 0) {
                        mx.forEach((item, index) => {
                            var arr = this.sendDataInfo.detailList.filter(item1 => item1.bgmId == item.bgmId && item1.spdId == item.spdId)
                            if (arr.length > 0) {
                                mx.splice(index, 1)
                            }
                        })
                        this.sendDataInfo.detailList.push(...mx)
                    } else {
                        this.sendDataInfo.detailList = mx
                    }
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.parentSearchData.bgmId = "";
                            this.parentSearchData.bgmName = "";
                            this.tableNextFocus(this.fField, this.seIndex);
                            this.selectedDetailsIndex = this.seIndex;
                            let refsElTable = this.$refs.mxTableRef;
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
                        }, 16.7)
                    });
                } else {
                    const params = {
                        //校验明细商品
                        formId: this.mxForm.jciId, //表单ID
                        unitId: this.sendDataInfo.cmId, //销售单位ID
                        bgmId: bgmIds, //商品id
                        ormId: this.ormId, //     组织ID
                        salesId: this.sendDataInfo.salesId, // 对方业务员ID
                        bgiTypes: bgiTypeArr, //	药品类型
                        taxs: bgiRateArr, //	税率
                        recId: this.sendDataInfo.recId, //收货人
                        hospitalId: this.sendDataInfo.hospitalId || "",
                    }
                    this.$http.checkSuMerge(params).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            res.result.forEach(item => {
                                this.dialogList.push(item)
                            })
                            if (
                                this.dialogList != null &&
                                this.dialogList.length > 0
                            ) {
                                flag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.sendDataInfo.detailList.forEach((item, index) => {
                                    if (item.bgmId == "" || item.bgmName == "") {
                                        this.sendDataInfo.detailList.splice(index, 1)
                                    }
                                })
                                if (this.sendDataInfo.detailList.length > 0) {
                                    mx.forEach((item, index) => {
                                        var arr = this.sendDataInfo.detailList.filter(item1 => item1.bgmId == item.bgmId && item1.spdId == item.spdId)
                                        if (arr.length > 0) {
                                            mx.splice(index, 1)
                                        }
                                    })
                                    this.sendDataInfo.detailList.push(...mx)
                                } else {
                                    this.sendDataInfo.detailList = mx
                                }
                                this.$nextTick(() => {
                                    setTimeout(() => {
                                        this.parentSearchData.bgmId = "";
                                        this.parentSearchData.bgmName = "";
                                        this.selectedDetailsIndex = this.seIndex;
                                        this.tableNextFocus(this.fField, this.seIndex);
                                        let refsElTable = this.$refs.mxTableRef;
                                        refsElTable.clearSelection();
                                        refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
                                    }, 16.7)
                                });
                            } else {
                                return false;
                            }
                        } else {
                            this.lineMessageBox(res);
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                    });
                }
            } else if (this.ppId == 'suomId') {
                Object.keys(this.sendDataInfo).forEach(key => {
                    if (val[key] != "" && val[key] != null && val[key] != undefined) {
                        this.$set(this.sendDataInfo, key, val[key])
                    }
                })
                this.$set(this.sendDataInfo, 'suomId', val.suomId)
                if (val.arrlistbychen.length > 0) {
                    var mx = JSON.parse(JSON.stringify(val.arrlistbychen))
                    if (mx.length > 0) {
                        this.sendDataInfo.detailList.forEach((item, index) => {
                            if (item.bgmId == "" || item.bgmName == "") {
                                this.sendDataInfo.detailList.splice(index, 1)
                            }
                        })
                        if (this.sendDataInfo.detailList.length > 0) {
                            mx.forEach((item, index) => {
                                var arr = this.sendDataInfo.detailList.filter(item1 => item1.bgmId == item.bgmId)
                                if (arr.length > 0) {
                                    mx.splice(index, 1)
                                }
                            })
                            this.sendDataInfo.detailList.push(...mx)
                        } else {
                            this.sendDataInfo.detailList = mx
                        }
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.parentSearchData.bgmId = "";
                                this.parentSearchData.bgmName = "";
                                this.tableNextFocus(this.fField, this.seIndex);
                                this.selectedDetailsIndex = this.seIndex;
                                let refsElTable = this.$refs.mxTableRef;
                                refsElTable.clearSelection();
                                refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
                            }, 16.7)
                        });
                    }
                }
            } else if (this.ppId == 'spCode') {
                var mx = JSON.parse(JSON.stringify(val.arrlistbychen))
                if (mx.length > 0) {
                    mx.forEach((item, index) => {
                        item.spName = val.spName
                    })
                    this.sendDataInfo.detailList.forEach((item, index) => {
                        if (item.bgmId == "" || item.bgmName == "") {
                            this.sendDataInfo.detailList.splice(index, 1)
                        }
                    })

                    // 优化：过滤掉与现有detailList中spdId重复的项
                    if (this.sendDataInfo.detailList.length > 0) {
                        // 使用filter替代forEach+splice避免索引问题
                        mx = mx.filter(item => {
                            // 检查当前项的spdId是否在detailList中已存在
                            const exists = this.sendDataInfo.detailList.some(detailItem =>
                                detailItem.spdId == item.spdId);
                            return !exists;
                        });

                        this.sendDataInfo.detailList.push(...mx)
                    } else {
                        this.sendDataInfo.detailList = mx
                    }

                    // 添加去重处理，防止detailList内部也有重复的spdId
                    this.removeDuplicateSpdId();
                }
            }
            this.DialogExtract = false;
        },
        removeDuplicateSpdId() {
            const seenSpdIds = new Set();
            this.sendDataInfo.detailList = this.sendDataInfo.detailList.filter(item => {
                // 如果spdId为空或者未定义，则不过滤该项
                if (!item.spdId) {
                    return true;
                }
                // 如果已见过该spdId，则过滤掉该项
                if (seenSpdIds.has(item.spdId)) {
                    return false;
                }
                // 记录新见到的spdId
                seenSpdIds.add(item.spdId);
                return true;
            });
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        tabHeight(val) {
            this.mxHeight = val;
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },

        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.detailList.length > 0) {
                }
                this.addDetail("sendDataInfo");
                return;
            }
            if (fField == "keydown") {
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        closeChild() {
            this.parentSearchData.bgmId = "";
            this.parentSearchData.bgmName = "";
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                this.addDetail("sendDataInfo");
                if (this.sendDataInfo.detailList[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                }
                return;
            } else if (field == "keydownnum") {
                if (this.sendDataInfo.detailList[index + 1] != undefined) {
                    this.$refs["woadPnumber"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                } else {
                    this.addDetail("sendDataInfo");
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                }
            } else if (field == "keydownprice") {
                if (this.sendDataInfo.detailList[index + 1] != undefined) {
                    this.$refs["psprice"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                } else {
                    this.addDetail("sendDataInfo");
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                }
            }
            this.$refs[field][index].focus();
        },
        selectedDetailsIndexChange(value) {
            this.selectedDetailsIndex = value;
            this.$nextTick(() => {
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.detailList[this.selectedDetailsIndex]
                );
            });
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                this.addDetail("sendDataInfo");
                return;
            } else if (e.key == "F2") {
                e.preventDefault();
                this.deleteDetails();
            } else if (e.key == "F4" && this.dataActionBox.actionType != 2) {//保存
                this.sendDataAction('sendDataInfo')
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.detailList.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.detailList.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.detailList[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.detailList.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.detailList.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.detailList[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },

        // 明细表格排序
        sortChange(column) {
            this.sendDataInfo.detailList = this.$common.sortChange(column, this.sendDataInfo.detailList, this.mxForm.jurconfigform, 'entityField')
        },

        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },

        //换行提示
        lineMessageBox(data) {
            console.log(data);

            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        //拦截提示
        verifyPustate(val) {
            if (val.cmSustate == 0) {
                this.$set(this, 'cmSustate', val.cmSustate)
                this.$set(this, 'cmSustateRemark', val.cmSustateRemark)
                this.$set(this, 'showCmSustateDialog', true)
                return false
            }
            return true
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, flag) {
            console.log(sId, index, type, sField, fField, flag, "测试");
            if (type == "salesName" || type == "caiAddress" || type == "recName" || type == 'secondcmName') {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            if (sField != undefined) {
                this.sField = sField;
            }

            if (type == "bgmName") {
                this.parentSearchData[type] = this.sendDataInfo.detailList[index][type];
                this.parentSearchData.surgeryType = this.sendDataInfo.surgeryType
            } else {
                for (const key in this.sendDataInfo) {
                    if (this.sendDataInfo[key] != null && this.sendDataInfo[key] !== "") {
                        this.parentSearchData[key] = this.sendDataInfo[key];
                    } else {
                        this.parentSearchData[key] = ""
                    }
                }
            }
            if (type == 'secondcmName') {
                delete this.parentSearchData.stId
            }


        },

        // 赋值字段
        paramValue(val) {
            console.log(this.sField, val);
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                if (
                    (item == "depName" && val[item] == null) ||
                    (item == "opmName" && val[item] == null) ||
                    (item == "depId" && val[item] == null) ||
                    (item == "opmId" && val[item] == null)
                ) {
                    this.sendDataInfo[item] = this.sendDataInfo[item];
                } else {
                    this.sendDataInfo[item] = val[item];
                }
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },

        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },

        //检索带回数据,
        changeInputModel(val) {
            console.log(val, this.seType);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.$nextTick(() => {
                    addEventListener("keyup", this.keyUp); //创建监听键盘事件
                    if (this.seType == "cmName") {
                        this.showDialog = false;
                        if (!this.verifyPustate(val)) return
                        let cmNameFlag = -1;
                        //销售单位
                        this.$http.checkCustomerSale({
                            //校验单位
                            formId: this.formDataList[0].jciId, //表单ID
                            unitId: val.cmId, //单位ID
                        }).then((res) => {
                            this.dialogList = []
                            if (res && res.status == 200) {
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    cmNameFlag = this.dialogList.findIndex(
                                        (item) => item.level == 0
                                    );
                                    this.showDialog = true;
                                }
                                if (cmNameFlag == -1) {
                                    this.parentSearchData.cmId = val.cmId;
                                    this.sendDataInfo.cmId = val.cmId;
                                    this.sendDataInfo.cmName = val.cmName;
                                    this.$http.queryDefaultSales({
                                        ids: [val.cmId]
                                    }).then((res) => {
                                        if (res && res.status == 200) {
                                            var valObj = {
                                                ...val,
                                                ...res.result,
                                            }
                                        }
                                        if (valObj.salesName && valObj.salesId && this.sField.indexOf('salesName') != -1 && this.sField.indexOf('salesId') != -1) {
                                            //对方业务员
                                            this.$http.checkSalesSale({
                                                //校验对方业务员
                                                formId: this.formDataList[0].jciId, //表单ID
                                                salesId: valObj.salesId, //业务员ID
                                            }).then((res) => {
                                                if (res && res.status == 200) {
                                                    let flag = -1;
                                                    if (res.result != null && res.result.length > 0) {
                                                        res.result.forEach(item => {
                                                            this.dialogList.push(item)
                                                        })
                                                        flag = this.dialogList.findIndex((item) => item.level == 0);
                                                        this.showDialog = true;
                                                    }
                                                    if (flag == -1) {
                                                        this.sendDataInfo.salesName = valObj.salesName;
                                                        this.sendDataInfo.salesId = valObj.salesId;
                                                        if (valObj.recName && valObj.recId && this.sField.indexOf('recName') != -1 && this.sField.indexOf('recId') != -1) {
                                                            //收货员
                                                            this.$http.checkRecSalesSale({
                                                                //校验收货员
                                                                formId: this.formDataList[0].jciId, //表单ID
                                                                salesId: valObj.recId, //业务员ID
                                                            }).then((res) => {
                                                                if (res && res.status == 200) {
                                                                    let salesFlag = -1;
                                                                    if (res.result != null && res.result.length > 0) {
                                                                        res.result.forEach(item => {
                                                                            this.dialogList.push(item)
                                                                        })
                                                                        salesFlag = this.dialogList.findIndex((item) => item.level == 0);
                                                                        this.showDialog = true;
                                                                    }
                                                                    if (salesFlag == -1) {
                                                                        this.paramValue(valObj);
                                                                    }
                                                                } else {
                                                                    this.lineMessageBox(res);
                                                                    return false;
                                                                }
                                                            }).catch((rej) => {
                                                                this.lineMessageBox(rej);
                                                            });
                                                        } else {
                                                            this.paramValue(valObj);
                                                        }
                                                    } else {
                                                        this.showDialog = true;
                                                    }
                                                } else {
                                                    this.lineMessageBox(res);
                                                    return false;
                                                }
                                            }).catch((rej) => {
                                                this.lineMessageBox(rej);
                                            });
                                        } else {
                                            this.paramValue(valObj);
                                        }
                                    }).catch((rej) => {
                                        this.lineMessageBox(rej);
                                    });

                                } else {
                                    this.showDialog = true;
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.parentSearchData.cmId = "";
                                this.clearValue();
                            }
                        }).catch((rej) => {
                            this.lineMessageBox(rej);
                            this.parentSearchData.cmId = "";
                            this.clearValue();
                        });
                    } else if (this.seType == "salesName") {
                        this.showDialog = false;
                        //对方业务员
                        this.$http.checkSalesSale({
                            //校验对方业务员
                            formId: this.formDataList[0].jciId, //表单ID
                            salesId: val.salesId, //业务员ID
                        }).then((res) => {
                            this.dialogList = []
                            if (res && res.status == 200) {
                                let flag = -1;
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex(
                                        (item) => item.level == 0
                                    );
                                    this.showDialog = true;
                                }
                                if (flag == -1) {
                                    this.paramValue(val);
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.clearValue();
                                return false;
                            }
                        }).catch((rej) => {
                            this.lineMessageBox(rej);
                            this.clearValue();
                        });
                    } else if (this.seType == "coName") {
                        //货主
                        this.$http.checkSuComey({
                            //校验对方业务员
                            formId: this.formDataList[0].jciId, //表单ID
                            coId: val.coId, //货主ID
                        }).then((res) => {
                            this.dialogList = []
                            if (res && res.status == 200) {
                                let flag = -1;
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex(item => item.level == 0);
                                    this.showDialog = true;
                                }
                                if (flag == -1) {
                                    this.coId = val.coId;
                                    this.sendDataInfo.ormId = this.ormId;
                                    this.paramValue(val);
                                } else {
                                    this.showDialog = true;
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.clearValue();
                                return false;
                            }
                        }).catch((rej) => {
                            this.lineMessageBox(rej);
                            this.clearValue();
                        });
                    } else if (this.seType == "bgmName") {
                        if (val.expidate == null || val.expidate == "" || val.expidate == undefined) {
                        } else {
                            if (val.expidate < this.$common.getNewDayTime()) {
                                this.tableNextFocus("bgmName", this.seIndex);
                                return this.$message({
                                    message: "该品种已过期，不允许销售!",
                                    type: "error",
                                });
                            }
                        }
                        val.costAmount = 0;
                        val.costMoney = 0;
                        this.$set(this.sendDataInfo.detailList, this.seIndex, JSON.parse(JSON.stringify(val)));
                        this.$nextTick(() => {
                            this.$set(this.sendDataInfo.detailList[this.seIndex], "woadPnumber", 0);
                            var sField = [];
                            if (this.sField) {
                                sField = this.sField.split(",");
                                sField.forEach((item) => {
                                    if (val[item]) {
                                        this.$set(this.sendDataInfo.detailList[this.seIndex], item, val[item]);
                                    }
                                });
                            }
                            this.parentSearchData.bgmId = "";
                            this.parentSearchData.bgmName = "";
                            this.tableNextFocus(this.fField, this.seIndex);
                            this.selectedDetailsIndex = this.seIndex;
                            let refsElTable = this.$refs.mxTableRef;
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
                        });
                    } else if (this.seType == "recName") {
                        //收货员
                        this.$http.checkRecSalesSale({
                            //校验收货员
                            formId: this.formDataList[0].jciId, //表单ID
                            salesId: val.salesId, //业务员ID
                        }).then((res) => {
                            this.dialogList = []
                            if (res && res.status == 200) {
                                let flag = -1;
                                if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                        this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex(item => item.level == 0);
                                    this.showDialog = true;
                                }
                                if (flag == -1) {
                                    this.paramValue(val);
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.clearValue();
                                return false;
                            }
                        }).catch((rej) => {
                            this.lineMessageBox(rej);
                            this.clearValue();
                        });
                    } else if (this.seType == "ht") {
                        for (let key in val) {
                            this.sendDataInfo[key] = val[key];
                        }
                        this.parentSearchData.cmId = val.cmId;
                        this.sendDataInfo.detailList = [];
                    } else {
                        this.paramValue(val);
                    }
                });
            }
        },
        //多选商品数据处理
        bgmSelect(val) {
            //商品明细
            let bgiTypeArr = [],
                bgiRateArr = [],
                bgmIds = [],
                bgsIds = [];
            var flag = false;
            this.sendDataInfo.detailList.forEach((v, index) => {
                if (
                    v.bgiType &&
                    v.bgiType != null &&
                    v.bgiType != "null" &&
                    v.bgmName != ""
                ) {
                    bgiTypeArr.push(v.bgiType);
                }
                if (this.seIndex != index) {
                    if (v.outRate && v.outRate != null && v.outRate != "null" && v.bgmName != "") {
                        bgiRateArr.push(v.outRate);
                    }
                }

            });
            val.forEach((item) => {
                if (
                    item.expidate == null ||
                    item.expidate == "" ||
                    item.expidate == undefined
                ) {
                } else {
                    if (item.expidate < this.$common.getNewDayTime()) {
                        flag = true;
                    }
                }
                if (!item.costAmount) {
                    item.costAmount = 0;
                }
                if (!item.costMoney) {
                    item.costMoney = 0
                }

                if (item.outRate && item.outRate != null && item.outRate != "null" && item.bgmName != "") {
                    bgiRateArr.push(item.outRate);
                }
                bgiTypeArr.push(item.bgiType);
                bgmIds.push(item.bgmId);
                bgsIds.push(item.bgsId);
            });
            bgiTypeArr.forEach((item, i) => {
                if (item == null || item == "null") bgiTypeArr.splice(i, 1);
            });
            if (flag) {
                return this.$message({
                    message: "该品种已过期，不允许销售!",
                    type: "error",
                });
            }
            this.$http
                .checkScopeSale({
                    //校验明细商品
                    formId: this.mxForm.jciId, //表单ID
                    unitId: this.sendDataInfo.cmId, //销售单位ID
                    bgmId: bgmIds, //商品id
                    bgsId: bgsIds,
                    ormId: this.ormId, //     组织ID
                    salesId: this.sendDataInfo.salesId, // 对方业务员ID
                    bgiTypes: bgiTypeArr, //	药品类型
                    taxs: bgiRateArr, //	税率
                    recId: this.sendDataInfo.recId, //收货人
                })
                .then((res) => {
                    this.dialogList = []
                    if (res && res.status == 200) {
                        let flag = -1;
                        res.result.forEach(item => {
                            this.dialogList.push(item)
                        })
                        if (this.dialogList != null && this.dialogList.length > 0) {
                            flag = this.dialogList.findIndex(
                                (item) => item.level == 0
                            );
                            this.showDialog = true;
                        }
                        if (flag == -1) {
                            if (
                                this.sendDataInfo.detailList &&
                                this.sendDataInfo.detailList.length > 0
                            ) {
                                var mx = JSON.parse(JSON.stringify(val));
                                mx.forEach(item => {
                                    item.woadPnumber = item.woadPnumber || 0
                                })
                                this.sendDataInfo.detailList.forEach(
                                    (item, index) => {
                                        if (item.bgmId == "" || item.bgmName == "") {
                                            this.sendDataInfo.detailList.splice(
                                                index,
                                                1
                                            );
                                        }
                                    }
                                );
                                const numberList = this.mxForm.jurconfigform.filter((item) => item.fieldType == "number").map((item) => item.entityField);
                                mx.forEach((item) => {
                                    this.sendDataInfo.detailList.push({});
                                    for (const key in this.detaislDataInfo) {
                                        const index = numberList.findIndex(
                                            (items) => items == key
                                        );
                                        if (index != -1 && !item[key]) {
                                            this.$set(this.sendDataInfo.detailList[this.sendDataInfo.detailList.length - 1], key, 0);
                                        } else {
                                            this.$set(this.sendDataInfo.detailList[this.sendDataInfo.detailList.length - 1], key, item[key] != undefined && item[key] != null ? item[key] : "");
                                        }
                                    }
                                    var sField = [];
                                    if (this.sField) {
                                        sField = this.sField.split(",");
                                        sField.forEach((item1) => {
                                            if (item[item1]) {
                                                this.$set(this.sendDataInfo.detailList[this.sendDataInfo.detailList.length - 1], item1, item[item1] || 0);
                                            }
                                        });
                                    }
                                });
                            } else {
                                const numberList = this.mxForm.jurconfigform
                                    .filter((item) => item.fieldType == "number")
                                    .map((item) => item.entityField);
                                this.sendDataInfo.detailList = [];
                                val.forEach((item, index) => {
                                    item.woadPnumber = item.woadPnumber || 0
                                    this.sendDataInfo.detailList.push({});
                                    for (const key in this.detaislDataInfo) {
                                        const index1 = numberList.findIndex(
                                            (items) => items == key
                                        );
                                        if (index1 != -1 && !val[key]) {
                                            this.$set(
                                                this.sendDataInfo.detailList[index],
                                                key,
                                                0
                                            );
                                        } else {
                                            this.$set(
                                                this.sendDataInfo.detailList[index],
                                                key,
                                                item[key] != undefined && item[key] != null
                                                    ? item[key]
                                                    : ""
                                            );
                                        }
                                    }
                                    var sField = [];
                                    if (this.sField) {
                                        sField = this.sField.split(",");
                                        sField.forEach((item1) => {
                                            if (item[item1]) {
                                                this.$set(this.sendDataInfo.detailList[index], item1, item[item1] || 0);
                                            }
                                        });
                                    }
                                });
                            }
                        } else {
                            this.$set(
                                this.sendDataInfo.detailList,
                                this.seIndex,
                                JSON.parse(JSON.stringify(this.detaislDataInfo))
                            );
                            return false;
                        }
                    } else {
                        this.lineMessageBox(res);
                    }
                })
                .catch((rej) => {
                    this.lineMessageBox(rej);

                    this.$set(
                        this.sendDataInfo.detailList,
                        this.seIndex,
                        JSON.parse(JSON.stringify(this.detaislDataInfo))
                    );
                });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        async surgeryClick() {
            // 成功回调 - value已是修剪后的值
            const params = {
                remark: "",
                surgeryType: this.ruleForm.surgeryType,
                umId: "",
                umName: this.ruleForm.umName,
                surgerydetailList: this.sendDataInfo.detailList.map(item => {
                    return {
                        bgmId: item.bgmId,
                        num: item.woadPnumber,
                        remark: "",
                        umId: "",
                        udId: "",
                    }
                })
            }
            const res = await this.$http.surgerymasteradd(params)
            if (res.status == 200) {
                this.$message.success(res.message)
                this.ruleForm.surgeryType = ""
                this.ruleForm.umName = ""
                this.surgeryTypeFlag = false
            } else {
                this.$message.error(res.message)
            }
        },
        //确认新增
        sendDataAction(formName1, type) {
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    if (this.sendDataInfo.detailList.length < 1) {
                        this.$message({
                            message: "请添加明细",
                            type: "error",
                        });
                        return false;
                    } else {
                        this.sendDataInfo.detailList.forEach((item, index) => {
                            if (item.bgmId == "") {
                                this.sendDataInfo.detailList.splice(index, 1);
                            }
                        });
                    }
                    if (this.sendDataInfo.orderId == "") {
                        for (let j = 0; j < this.sendDataInfo.detailList.length; j++) {
                            const itemvs = this.sendDataInfo.detailList[j];
                            if (
                                itemvs.woadPnumber <= 0 ||
                                itemvs.woadPnumber > itemvs.saleableNum
                            ) {
                                this.$message({
                                    message: "请填写商品、合理的销售数量",
                                    type: "error",
                                });
                                this.$set(itemvs, "woadPnumber", 0);
                                return false;
                            }
                        }
                    }
                    var flagNum = false
                    var indexNum = 0
                    this.sendDataInfo.detailList.forEach((item, index) => {
                        if ((item.woadPnumber == "" || item.woadPnumber == null || item.woadPnumber <= 0) && !flagNum) {
                            indexNum = index
                            flagNum = true
                        }
                    })
                    if (flagNum) {
                        return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.detailList[indexNum].bgmName}数量不能为空或为零！`)
                    }
                    for (let key in this.sendDataInfo) {
                        if (key == "") delete this.sendDataInfo[key];
                    }
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    return false;
                }
                if (type == 1) {
                    this.ruleForm.surgeryType = ""
                    this.ruleForm.umName = ""
                    this.surgeryTypeFlag = true
                    return
                }
                this.sub()
            });
        },
        async sub() {
            var responseData
            this.sendDataInfo.totalCount = this.sendDataInfo.detailList.length
            if (this.dataActionBox.actionType == 0) {
                responseData = await this.$http.pwoapplyadd(this.sendDataInfo);
            } else {
                responseData = await this.$http.pwoapplyupdate(this.sendDataInfo);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                if (this.dataActionBox.actionType == 0) {
                    this.$refs.operSelect.openBox(responseData.result);
                } else {
                    this.$emit("drawerCancel", true);
                }
            } else {
                this.$message.error(responseData.message);
            }
        },
        drawerCancel() {
            this.$emit("drawerCancel", true);
        },
        conAdd() {
            this.init();
            this.dataActionBox.actionType = 0;
            this.initDefaultValue();
            this.checkIsBuyer();
        },
        //新增明细
        addDetail(sendDataInfo) {
            var flag = false;
            if (this.sendDataInfo.detailList.length > 0) {
                this.sendDataInfo.detailList.forEach((item) => {
                    if (item.bgmId == "") {
                        flag = true;
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                });
            }
            if (flag) {
                return;
            }
            if (!this.$refs[sendDataInfo]) {
                return
            }
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.detailList.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.detailList.push({});
                    var index = this.sendDataInfo.detailList.length - 1;
                    for (const key in this.detaislDataInfo) {
                        this.$set(
                            this.sendDataInfo.detailList[index],
                            key,
                            this.detaislDataInfo[key]
                        );
                    }
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.detailList.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        //取消
        initActionBox(formName1, formName2) {
            this.$confirm(
                "确定取消" + this.dataActionBox.boxTitle + "吗?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    this.$emit("drawerCancel");
                    this.init();
                    this.$refs[formName1].resetFields();
                    this.$refs[formName2].resetFields();
                })
                .catch(() => { });
        },

        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "detailList") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();

            this.sendDataInfo.detailList = [];
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalNumber = 0;
            this.checkIsBuyer();
        },
        //上级流入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.showTabs = this.actionData.formData[0].jciName;
            var oldData = this.actionData.oldData;
            this.ormId = oldData.ormId
                ? oldData.ormId
                : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.checkIsBuyer();
            } else if (this.dataActionBox.actionType == 1) {
                this.coId = oldData.coId;
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (const key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key]);
                }
                this.parentSearchData.cmId = oldData.cmId;
                for (let key in this.sendDataInfo) {
                    if (this.sendDataInfo[key] == null) this.sendDataInfo[key] = "";
                }

            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
            this.sendDataInfo.orderTime = this.$moment().valueOf();
        },

        //删除明细
        deleteDetails() {
            var item = this.sendDataInfo.detailList[this.selectedDetailsIndex]
            console.log(item);
            if (item.spCode != "" && item.spCode != null && item.spCode != undefined) {
                // 删除所有具有相同spCode的项
                this.sendDataInfo.detailList = this.sendDataInfo.detailList.filter(val =>
                    !val.spCode || val.spCode == "" || val.spCode != item.spCode
                );
            } else {
                this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1);
            }
            this.$nextTick(() => {
                if (this.sendDataInfo.detailList.length > 1) {
                    if (this.sendDataInfo.detailList.length < this.selectedDetailsIndex) {
                        this.selectedDetailsIndex = 0
                    }
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.detailList[this.selectedDetailsIndex]
                    );
                } else {
                    this.selectedDetailsIndex = 0;
                }
            });
        },

        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
            if (ormInfo.isDefaultopm == 1) {
                if (info.opmSalesperson == 1) {
                    this.sendDataInfo.depName = info.depName;
                    this.sendDataInfo.depId = info.depId;
                    this.sendDataInfo.opmName = info.opmName;
                    this.sendDataInfo.opmId = info.opmId;
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "opmName" ||
                            item.entityField == "depName"
                        )
                            item.isChange = 0;
                    });
                }
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var arr = [{ entityField: "detailList" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.sendDataInfo.orderTime = this.$moment().valueOf();
        },
        // 获取字典数据
        async dictSurgeryqueryList() {
            let responseData = await this.$http.dictSurgeryqueryList({ surgeryName: "" });
            if (responseData.status == 200) {
                this.surgeryTypeList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log(this.$route)
        this.$dbCache.Record_Get(4).then((res) => {//选择明细后不允许更换单位
            //明细拦截
            let obj = res
            if (obj.isEnable == 1) this.detailRules = true;
        });
        this.dictSurgeryqueryList()
        this.$nextTick(() => {
            this.openBox();

            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        };
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
#mainInfo .remark1 ::v-deep .el-form-item__content {
    width: 400px !important;
}
#mainInfo .remark ::v-deep .el-textarea__inner {
    width: 400px !important;
}
</style>
<style>
.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>